import { Observable } from 'rxjs';

import { Component } from '@angular/core';
import { Select } from '@ngxs/store';
import { ChargebeeState } from '@core/state/chargebee.state';
import { IAdSpend, MySubscription } from '@core/models';
import { CURRENCIES } from '@core/constants';

@Component({
  selector: 'aayn-package',
  templateUrl: 'package.component.html'
})
export class PackageComponent {
  @Select(ChargebeeState.subscription) subscription$?: Observable<MySubscription>;

  @Select(ChargebeeState.isAppsumoUser) isAppSumoUser$!: Observable<boolean>;

  @Select(ChargebeeState.adSpend) adSpend$!: Observable<IAdSpend>;

  CURRENCIES = CURRENCIES;
}
